import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const AssessmentTemplates = ({ templates = [] }) => {
  const shouldDisplay = templates.length > 0;
  if (!shouldDisplay) {
    return null;
  }

  return (
    <>
      <FormattedMessage
        id="accounts.add-client.assessment-templates.heading"
        defaultMessage="Assign Assessment Templates"
        tagName="h1"
      />
      <ul>
        {templates.map(({ node: { id, title } }) => (
          <li key={id}>{title}</li>
        ))}
      </ul>
    </>
  );
};

AssessmentTemplates.propTypes = {
  templates: PropTypes.arrayOf(PropTypes.shape({ node: PropTypes.any.isRequired })).isRequired,
};

export default AssessmentTemplates;
